"use strict";
var __webpack_require__ = {};
(()=>{
    __webpack_require__.d = (exports1, definition)=>{
        for(var key in definition)if (__webpack_require__.o(definition, key) && !__webpack_require__.o(exports1, key)) Object.defineProperty(exports1, key, {
            enumerable: true,
            get: definition[key]
        });
    };
})();
(()=>{
    __webpack_require__.o = (obj, prop)=>Object.prototype.hasOwnProperty.call(obj, prop);
})();
(()=>{
    __webpack_require__.r = (exports1)=>{
        if ('undefined' != typeof Symbol && Symbol.toStringTag) Object.defineProperty(exports1, Symbol.toStringTag, {
            value: 'Module'
        });
        Object.defineProperty(exports1, '__esModule', {
            value: true
        });
    };
})();
var __webpack_exports__ = {};
__webpack_require__.r(__webpack_exports__);
__webpack_require__.d(__webpack_exports__, {
    allDomainIDs: ()=>allDomainIDs,
    cloudHostnameMap: ()=>cloudHostnameMap,
    regionEnvMap: ()=>regionEnvMap,
    domainIDHostnameMap: ()=>domainIDHostnameMap,
    domainIDNameMap: ()=>domainIDNameMap
});
const row_js_namespaceObject = require("../aegis-api-config/row.js");
const ttp_js_namespaceObject = require("../aegis-api-config/ttp.js");
const cloudHostnameMap = {
    localhost: 'local',
    [row_js_namespaceObject.rowOtherHostnameConfig.eden]: 'local',
    [row_js_namespaceObject.rowOtherHostnameConfig.arco]: 'sandbox',
    [row_js_namespaceObject.rowOtherHostnameConfig.arcoByte]: 'sandbox',
    [row_js_namespaceObject.rowOtherHostnameConfig.developer]: 'sandbox',
    [row_js_namespaceObject.rowOtherHostnameConfig.developerBoe]: 'sandbox',
    [row_js_namespaceObject.rowOtherHostnameConfig.docsDev]: 'sandbox',
    [row_js_namespaceObject.rowHostnameConfig.sandbox]: 'sandbox',
    [row_js_namespaceObject.rowHostnameConfig.hl]: 'hl',
    [row_js_namespaceObject.rowHostnameConfig.lq]: 'lq',
    [row_js_namespaceObject.rowHostnameConfig.pd]: 'pd',
    [row_js_namespaceObject.rowOtherHostnameConfig.huailai]: 'hl',
    [row_js_namespaceObject.rowOtherHostnameConfig.cloudBoe]: 'boe',
    [row_js_namespaceObject.rowHostnameConfig.boe]: 'boe',
    [row_js_namespaceObject.rowHostnameConfig.us]: 'us',
    [row_js_namespaceObject.rowHostnameConfig.i18n]: 'i18n',
    [row_js_namespaceObject.rowHostnameConfig["i18n-sg"]]: 'i18n-sg',
    [row_js_namespaceObject.rowHostnameConfig.online]: 'online',
    [row_js_namespaceObject.rowHostnameConfig["boe-i18n"]]: 'boe-i18n',
    [row_js_namespaceObject.rowHostnameConfig.tx]: 'tx',
    [ttp_js_namespaceObject.ttpHostnameConfig["tx-tt"]]: 'tx-tt',
    [ttp_js_namespaceObject.ttpHostnameConfig["ttp-us"]]: 'ttp-us',
    [row_js_namespaceObject.rowHostnameConfig["ttp-us-limited"]]: 'ttp-us-limited',
    [ttp_js_namespaceObject.ttpHostnameConfig["ttp-row"]]: 'ttp-row',
    [ttp_js_namespaceObject.ttpHostnameConfig["ttp-row-sg"]]: 'ttp-row-sg',
    [row_js_namespaceObject.rowOtherHostnameConfig.backupOnline]: 'online',
    [row_js_namespaceObject.rowOtherHostnameConfig.backupUs]: 'us',
    [row_js_namespaceObject.rowOtherHostnameConfig.backupI18n]: 'i18n',
    [row_js_namespaceObject.rowOtherHostnameConfig.backupTtpUsLimited]: 'ttp-us-limited',
    [ttp_js_namespaceObject.ttpOtherHostnameConfig.backupTtpUs]: 'ttp-us',
    [row_js_namespaceObject.rowOtherHostnameConfig.backupBoe]: 'boe',
    [row_js_namespaceObject.rowOtherHostnameConfig.backupSinfXfl]: 'sinf-xfl',
    [row_js_namespaceObject.rowOtherHostnameConfig.backupSinf]: 'sinf',
    [row_js_namespaceObject.rowOtherHostnameConfig.backupSinfBoe]: 'sinf-boe',
    [row_js_namespaceObject.rowOtherHostnameConfig.test]: 'sandbox',
    [row_js_namespaceObject.rowHostnameConfig.xfl]: 'xfl',
    [row_js_namespaceObject.rowHostnameConfig["sinf-xfl-boe"]]: 'sinf-xfl-boe',
    [row_js_namespaceObject.rowHostnameConfig["sinf-xfl"]]: 'sinf-xfl',
    [row_js_namespaceObject.rowHostnameConfig["sinf-boe"]]: 'sinf-boe',
    [row_js_namespaceObject.rowHostnameConfig.sinf]: 'sinf',
    [row_js_namespaceObject.rowHostnameConfig.sinfi18n]: 'sinfi18n',
    [row_js_namespaceObject.rowHostnameConfig.sinfonlinea]: 'sinfonlinea',
    [row_js_namespaceObject.rowHostnameConfig.volcgroup]: 'volcgroup',
    [row_js_namespaceObject.rowHostnameConfig["volcgroup-boe"]]: 'volcgroup-boe',
    [ttp_js_namespaceObject.ttpHostnameConfig["ttp-eu"]]: 'ttp-eu',
    [ttp_js_namespaceObject.ttpHostnameConfig["ttp-eu-de"]]: 'ttp-eu-de'
};
const regionEnvMap = {
    local: {
        region: 'cn',
        env: 'local'
    },
    sandbox: {
        region: 'cn',
        env: 'sandbox'
    },
    boe: {
        region: 'cn',
        env: 'boe'
    },
    online: {
        region: 'cn',
        env: 'prod'
    },
    hl: {
        region: 'cn',
        env: 'hl'
    },
    lq: {
        region: 'cn',
        env: 'lq'
    },
    pd: {
        region: 'cn',
        env: 'pd'
    },
    i18n: {
        region: 'i18n',
        env: 'prod'
    },
    'i18n-sg': {
        region: 'i18n',
        env: 'sg'
    },
    us: {
        region: 'us',
        env: 'prod'
    },
    'boe-i18n': {
        region: 'i18n',
        env: 'boe'
    },
    tx: {
        region: 'tx',
        env: 'prod'
    },
    'tx-tt': {
        region: 'tx-tt',
        env: 'prod'
    },
    'ttp-us': {
        region: 'ttp-us',
        env: 'prod'
    },
    'ttp-us-limited': {
        region: 'ttp-us-limited',
        env: 'prod'
    },
    xfl: {
        region: 'xfl',
        env: 'prod'
    },
    'sinf-xfl-boe': {
        region: 'sinf-xfl',
        env: 'boe'
    },
    'sinf-xfl': {
        region: 'sinf-xfl',
        env: 'prod'
    },
    'sinf-boe': {
        region: 'sinf',
        env: 'boe'
    },
    sinf: {
        region: 'sinf',
        env: 'prod'
    },
    sinfi18n: {
        region: 'sinfi18n',
        env: 'prod'
    },
    sinfonlinea: {
        region: 'sinfonlinea',
        env: 'prod'
    },
    volcgroup: {
        region: 'volcgroup',
        env: 'prod'
    },
    'volcgroup-boe': {
        region: 'volcgroup-boe',
        env: 'boe'
    },
    'ttp-row': {
        region: 'ttp-row',
        env: 'prod'
    },
    'ttp-row-sg': {
        region: 'ttp-row',
        env: 'sg'
    },
    'ttp-eu': {
        region: 'ttp-eu',
        env: 'prod'
    },
    'ttp-eu-de': {
        region: 'ttp-eu',
        env: 'de'
    },
    'i18n-bd': {
        region: 'i18n-bd',
        env: 'prod'
    },
    'i18n-bd-de': {
        region: 'i18n-bd',
        env: 'de'
    }
};
const allDomainIDs = Object.keys(regionEnvMap);
const domainIDNameMap = {
    boe: 'BOE',
    'boe-i18n': 'BOE - i18n',
    online: 'CN',
    hl: 'CN - HL',
    pd: 'CN - PD',
    us: 'US',
    i18n: 'I18N - TT',
    'i18n-sg': 'I18N - TT - SG',
    'ttp-us-limited': 'US - TTP BDEE',
    'ttp-us': 'US - TTP USTS',
    sandbox: 'SANDBOX',
    local: 'LOCAL',
    'tx-tt': 'US - TTP USTS',
    lq: 'CN - LQ',
    tx: 'US - TTP SIMULAT',
    xfl: 'XFL',
    'sinf-xfl': 'SINF - XFL',
    'sinf-xfl-boe': 'SINF - XFL BOE',
    'sinf-boe': 'SINF - BOE',
    sinf: 'SINF',
    sinfi18n: 'SINF - i18n',
    sinfonlinea: 'SINFONLINEA',
    volcgroup: 'VOLCGROUP',
    'volcgroup-boe': 'VOLCGROUP - BOE',
    'ttp-row': 'I18N - TT',
    'ttp-row-sg': 'I18N - TT - SG',
    'ttp-eu': 'EU - TTP',
    'ttp-eu-de': 'EU - TTP - DE',
    'i18n-bd': 'I18N - BD',
    'i18n-bd-de': 'I18N - BD - DE'
};
const domainIDHostnameMap = {
    sandbox: row_js_namespaceObject.rowHostnameConfig.sandbox,
    boe: row_js_namespaceObject.rowHostnameConfig.boe,
    online: row_js_namespaceObject.rowHostnameConfig.online,
    hl: row_js_namespaceObject.rowHostnameConfig.hl,
    lq: row_js_namespaceObject.rowHostnameConfig.lq,
    pd: row_js_namespaceObject.rowHostnameConfig.pd,
    us: row_js_namespaceObject.rowHostnameConfig.us,
    i18n: row_js_namespaceObject.rowHostnameConfig.i18n,
    'i18n-sg': row_js_namespaceObject.rowHostnameConfig["i18n-sg"],
    'boe-i18n': row_js_namespaceObject.rowHostnameConfig["boe-i18n"],
    'ttp-us': ttp_js_namespaceObject.ttpHostnameConfig["ttp-us"],
    'tx-tt': ttp_js_namespaceObject.ttpHostnameConfig["tx-tt"],
    'ttp-us-limited': row_js_namespaceObject.rowHostnameConfig["ttp-us-limited"],
    tx: row_js_namespaceObject.rowHostnameConfig.tx,
    xfl: row_js_namespaceObject.rowHostnameConfig.xfl,
    'sinf-xfl': row_js_namespaceObject.rowHostnameConfig["sinf-xfl"],
    'sinf-xfl-boe': row_js_namespaceObject.rowHostnameConfig["sinf-xfl-boe"],
    'sinf-boe': row_js_namespaceObject.rowHostnameConfig["sinf-boe"],
    sinf: row_js_namespaceObject.rowHostnameConfig.sinf,
    sinfi18n: row_js_namespaceObject.rowHostnameConfig.sinfi18n,
    sinfonlinea: row_js_namespaceObject.rowHostnameConfig.sinfonlinea,
    volcgroup: row_js_namespaceObject.rowHostnameConfig.volcgroup,
    'volcgroup-boe': row_js_namespaceObject.rowHostnameConfig["volcgroup-boe"],
    'ttp-row': ttp_js_namespaceObject.ttpHostnameConfig["ttp-row"],
    'ttp-row-sg': ttp_js_namespaceObject.ttpHostnameConfig["ttp-row-sg"],
    'ttp-eu': ttp_js_namespaceObject.ttpHostnameConfig["ttp-eu"],
    'ttp-eu-de': ttp_js_namespaceObject.ttpHostnameConfig["ttp-eu-de"],
    'i18n-bd': row_js_namespaceObject.rowHostnameConfig["i18n-bd"],
    'i18n-bd-de': row_js_namespaceObject.rowHostnameConfig["i18n-bd-de"]
};
exports.allDomainIDs = __webpack_exports__.allDomainIDs;
exports.cloudHostnameMap = __webpack_exports__.cloudHostnameMap;
exports.domainIDHostnameMap = __webpack_exports__.domainIDHostnameMap;
exports.domainIDNameMap = __webpack_exports__.domainIDNameMap;
exports.regionEnvMap = __webpack_exports__.regionEnvMap;
for(var __webpack_i__ in __webpack_exports__)if (-1 === [
    "allDomainIDs",
    "cloudHostnameMap",
    "domainIDHostnameMap",
    "domainIDNameMap",
    "regionEnvMap"
].indexOf(__webpack_i__)) exports[__webpack_i__] = __webpack_exports__[__webpack_i__];
Object.defineProperty(exports, '__esModule', {
    value: true
});
